import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Admin from "@/pages/admin/AdminCockpit";
import { Loader2 } from "lucide-react";

export default function AdminRoute() {
  const { loading, user } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.platform_role !== "super_admin") return <Navigate to="/" replace />;
  return <Admin />;
}
